import { gql, useQuery } from "@apollo/client";
import React, { Suspense } from "react";
import { Route, Switch } from "react-router-dom";
import Content from "./components/Content";
import Info from "./components/Info";
import InfoDisabilitas from "./components/infodisabilitas";
import Navigation from "./components/Navbar";

const SelayangPandang = React.lazy(() =>
  import("./components/SelayangPandang")
);

const GET_ALL_OPD = gql`
  query {
    opd {
      id
      name
    }
    total_asn_line_chart {
      bulan
      month
      total
      tahun
    }
    pertumbuhan_jabatan {
      fungsional
      pelaksana
      struktural
      bulan
      tahun
    }
  }
`;

export default function App() {
  const { loading, data } = useQuery(GET_ALL_OPD);

  if (loading) {
    return <div>Loading..</div>;
  }

  return (
    <React.Fragment>
      <Navigation />
      <Switch>
        <Route path="/" exact>
          <Suspense fallback="loading...">
            <SelayangPandang
              lineChartData={data?.total_asn_line_chart}
              pertumbuhanJabatan={data?.pertumbuhan_jabatan}
            />
          </Suspense>
        </Route>

        <Route path="/statistik">
          <Content>
            <Info listOpd={data?.opd} />
          </Content>
        </Route>
        <Route path="/statistikASNDisabilitas">
          <Content>
            <InfoDisabilitas listOpd={data?.opd} />
          </Content>
        </Route>
        {/* <Route path="/trend">
          <Trend />
        </Route> */}
      </Switch>
    </React.Fragment>
  );
}
